import React, { Component } from "react";
import ClassNames from "classnames";

export default class PriceListItem extends Component {

  render() {
    const { title, display, price, unit, isRecommended = false, children } = this.props;
    let classNames = "thumbnail price-list-item";

    if (isRecommended) {
      classNames = ClassNames(classNames, "recommended");
    }

    return (
      <div className={classNames}>
        <div className="price-list-header">
          <h4>{title}</h4>
        </div>
        <div className="price-list-price">
          <span className="price-list-display">{display} DISPLAYS</span>
          <h2 className="price-list-amount">{price}</h2>
          <span className="price-list-unit">{unit}</span>
        </div>
        <div className="price-list-body">
          {children}
        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Page/Pricing/PriceListItem.js